"use client";

import type { AnchorHTMLAttributes, CSSProperties } from "react";

/** App Store 公式バッジ（英語・黒） */
export const APP_STORE_BADGE_SRC =
  "/images/native-app/download-on-the-app-store.svg";

const BADGE_ASPECT_RATIO = 119.66407 / 40;

const sizeMap = {
  sm: { width: 115 },
  md: { width: 135 },
  lg: { width: 155 },
} as const;

type AppStoreButtonProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> & {
  href?: string;
  size?: keyof typeof sizeMap;
  fullWidth?: boolean;
};

export function AppStoreButton({
  href = "",
  size = "md",
  fullWidth = false,
  className,
  style,
  ...props
}: AppStoreButtonProps) {
  const width = fullWidth ? undefined : sizeMap[size].width;
  const height =
    width !== undefined ? Math.round(width / BADGE_ASPECT_RATIO) : undefined;

  const rootStyle: CSSProperties = {
    display: "block",
    width: fullWidth ? "100%" : width,
    lineHeight: 0,
    ...style,
  };

  const image = (
    <img
      src={APP_STORE_BADGE_SRC}
      alt=""
      width={width}
      height={height}
      style={{
        width: fullWidth ? "100%" : width,
        height: "auto",
        display: "block",
      }}
    />
  );

  const ariaLabel = props["aria-label"] ?? "App Storeからダウンロード";

  if (!href) {
    return (
      <span className={className} aria-label={ariaLabel} style={rootStyle}>
        {image}
      </span>
    );
  }

  return (
    <a
      {...props}
      href={href}
      className={className}
      aria-label={ariaLabel}
      style={rootStyle}
    >
      {image}
    </a>
  );
}
